import { createFetch, responseBody } from '@zapier/identity-fetch';

export const fetch = createFetch({
  // Removes authenticationError middleware so we
  // do not throw errors on 401s since those are expected
  afterResponse: [responseBody],
});
